import http from './http'
const emailCenterApi = '/EmailCenter'


function getEmailServiceSettingList() {
  return http.get(`${emailCenterApi}/getEmailServiceSettingList`)
}
function getUserFolder(params) {
  return http.get(`${emailCenterApi}/getUserFolder`,params)
}
function downLoadEmailFile(params) {
  return http.get(`${emailCenterApi}/downLoadEmailFile`,params)
}
function getFolderById(params) {
  return http.get(`${emailCenterApi}/getFolderById`,params)
}
function getEmailsByFolderId(params) {
  return http.post(`${emailCenterApi}/getEmailsByFolderId`,params)
}
function addOrUpdateSignature(params) {
  return http.post(`${emailCenterApi}/addOrUpdateSignature`,params)
}

function getEmailServiceList() {
  return http.get(`${emailCenterApi}/getEmailServiceList`)
}
function addorUpdateAccount(params) {
  return http.post(`${emailCenterApi}/addorUpdateAccount`, params)
}
function activeEmailAccount(params) {
  return http.get(`${emailCenterApi}/activeEmailAccount`, params)
}

function deleteEmail(params) {
  return http.delete(`${emailCenterApi}/deleteEmail`, params)
}

function starEmail(params) {
  return http.get(`${emailCenterApi}/starEmail`, params)
}
function getMBLEmail(params) {
  return http.post(`${emailCenterApi}/getMBLEmail`, params)
}

function readEmail(params) {
  return http.get(`${emailCenterApi}/readEmail`, params)
}

function moveEmail(params) {
  return http.get(`${emailCenterApi}/moveEmail`, params)
}

function receiveEmail() {
  return http.get(`${emailCenterApi}/receiveEmail`)
}


function sendEmailWithFiles(formData) {
  return http.upload(`/api${emailCenterApi}/sendEmail`, formData)
}
function draftEmailWithFiles(formData) {
  return http.upload(`/api${emailCenterApi}/draftsEmail`, formData)
}

function folderReName(params) {
  return http.put(`${emailCenterApi}/folderReName`,params)
}
function addorUpdateFolder(params) {
  return http.post(`${emailCenterApi}/addorUpdateFolder`,params)
}

function deleteFolder(params) {
  return http.delete(`${emailCenterApi}/deleteFolder`,params)
}

export {
    getEmailsByFolderId,
    getUserFolder,
    folderReName,
    getEmailServiceSettingList,
    getEmailServiceList,
    addorUpdateAccount,
    activeEmailAccount,
    deleteEmail,
    starEmail,
    readEmail,
    moveEmail,
    receiveEmail,
    sendEmailWithFiles,
    draftEmailWithFiles,
    addorUpdateFolder,
    deleteFolder,
    getFolderById,
    addOrUpdateSignature,
    downLoadEmailFile,
    getMBLEmail
}